// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconGraphicCallOut: React.FC<{}> = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="317"
            height="61"
            viewBox="0 0 317 61"
        >
            <defs>
                <pattern id="c" width="100%" height="100%" x="0%" patternUnits="objectBoundingBox">
                    <use xlinkHref="#a" transform="scale(.83333)" />
                </pattern>
                <image
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAAs0lEQVRoBe2YQQrDMAwE4/7J/3+AH9XS4x7FkG0Dk5vAkuIZC4zX3vt9Db5zzhosv+6u/5r8zD+udQO/tqIBDUACHiEIEKdrACOEBR5vYHSv+cK6+24zrf94A24AziBO1wBGCAtoAALE6RrACGEBDUCAOH1N7x6+C2HmWcAZSB79SAN95tlRA8mjH2mgzzw7aiB59CPfhfrMs6MzkDz6kQb6zLOjBpJHP9JAn3l21EDy6EcfG0kbmWsMNT0AAAAASUVORK5CYII="
                    id="a"
                    width="48"
                    height="48"
                />
                <path id="b" d="M0,0 L1366,0 L1366,3626 L0,3626 L0,0 Z" />
            </defs>
            <g fill="none" fillRule="evenodd" transform="translate(-694 -820)">
                <use xlinkHref="#b" fill="#FFF" />
                <g transform="translate(694 820)">
                    <g transform="translate(52)">
                        <text fill="#3B3B3B" fontFamily="Adelle-Regular, Adelle" fontSize="14">
                            <tspan x="0" y="53">
                                Lorem ipsum dolor sit amet consectetur.
                            </tspan>
                        </text>
                        <path
                            fill="#CD4A23"
                            fillRule="nonzero"
                            d="M17.6834392,9.79791395 C18.1055203,9.37548892 18.1055203,8.62451108 17.6834392,8.20208605 L9.80459209,0.316818774 C9.38251099,-0.105606258 8.6321446,-0.105606258 8.21006351,0.316818774 C7.78798241,0.739243807 7.78798241,1.49022164 8.21006351,1.91264668 L14.1660967,7.87353325 L1.12554958,7.87353325 C0.515876893,7.87353325 -1.42108547e-14,8.38983051 -1.42108547e-14,9 C-1.42108547e-14,9.61016949 0.515876893,10.1264668 1.12554958,10.1264668 L14.1660967,10.1264668 L8.21006351,16.0873533 C7.78798241,16.5097784 7.78798241,17.2607562 8.21006351,17.6831812 C8.6790425,18.1056063 9.38251099,18.1056063 9.80459209,17.6831812 L17.6834392,9.79791395 Z"
                            transform="translate(135 4.5)"
                        />
                        <text fill="#0C0908" fontFamily="TVNordEF-BlackCon" fontSize="24">
                            <tspan x="0" y="21">
                                {"{H4 Headline}"}
                            </tspan>
                        </text>
                    </g>
                    <rect width="40" height="40" fill="url(#c)" />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconGraphicCallOut);
